import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'
import { licenseShape } from '../../../../lib/shapes'
import FieldsetItem from '../../../../components/FieldsetItem'

class LicenseSummary extends React.Component {
  static propTypes = {
    license: licenseShape.isRequired,
    lookupSku: PropTypes.func.isRequired,
    renewal: licenseShape,
  }

  render = () => {
    const { props } = this
    const isCanceled = props.renewal && props.renewal.cancelledDate
    const style = isCanceled ? { opacity: 0.25 } : {}
    const skuChanged = props.renewal && props.license.sku !== props.renewal.sku
    const newSkuName =
      skuChanged && this.props.lookupSku(props.renewal.sku).name
    const isRenewed = !isCanceled && !skuChanged && !!props.renewal
    return (
      <React.Fragment>
        <Card body>
          {isRenewed && (
            <div className="status bg-success text-white">RENEWED</div>
          )}
          {isCanceled && (
            <div className="status bg-danger text-white">CANCELLED</div>
          )}
          {skuChanged && (
            <div className="status bg-warning text-white">CHANGED</div>
          )}
          <FieldsetItem
            data={props.license.licenseId}
            style={style}
            title="License Id"
          />
          <FieldsetItem style={style} title="Product">
            {isRenewed && (
              <div className="text-success">
                {props.license.sku}&nbsp;&mdash; {props.license.name}
              </div>
            )}
            {skuChanged && (
              <React.Fragment>
                <div className="text-decoration-line-through">
                  {props.license.sku}&nbsp;&mdash; {props.license.name}
                </div>
                <div className="text-warning">
                  {props.renewal.sku}&nbsp;&mdash; {newSkuName}
                </div>
              </React.Fragment>
            )}
            {!isRenewed && !skuChanged && (
              <div>
                {props.license.sku}&nbsp;&mdash; {props.license.name}
              </div>
            )}
          </FieldsetItem>
          <FieldsetItem
            data={props.license.schoolName}
            style={style}
            title="Assigned To"
          />
        </Card>
        <style>
          {`
            .status {
              padding: 5px 10px;
              position: absolute;
              right: 0;
            }
          `}
        </style>
      </React.Fragment>
    )
  }
}
export default LicenseSummary
